import React from 'react';
import Relatorio from '../../../../components/v2/relatorio/Relatorio';
import { MODULE, API_URL } from '../../../../consts';
import { ComponentBase } from '../../../../base';


class DistribuicaoNotasSituacaoGeral extends ComponentBase {
  get columns() {
    return [
      {
        header: '#',
        accessor: 'row',
        minWidth: 50,
        Cell: row => <div>{row.index + 1}</div>,
        footer: {
          mediaNacional: {
            accessor: '',
            default: '-',
          },
        },
      },
      {
        header: 'Polo',
        withSortIcon: true,
        accessor: 'polo_descricao',
        Cell: d => (<div className="column-left">{d.value}</div>),
        next: {
          pathname: '/relatorios/v2/distribuicao-notas-situacao-time',
          stateFields: ['polo'],
        },
        minWidth: 200,
        footer: {
          mediaNacional: {
            accessor: '',
            default: 'Dist. Nacional',
          },
        },
      },
      {
        header: 'Corrigidas',
        withSortIcon: true,
        accessor: 'nr_corrigidas',
        minWidth: 100,
        defaultValue: 0,
        footer: {
          mediaNacional: {
            accessor: 'nr_corrigidas',
            default: '-',
          },
        },
      },
      {
        header: 'Situação',
        withSortIcon: true,
        accessor: 'nr_situacoes',
        minWidth: 100,
        defaultValue: 0,
        footer: {
          mediaNacional: {
            accessor: 'media_situacoes',
            default: '-',
          },
        },
      },
      {
        header: MODULE === 'enem' ? 'FEA (%)' : 'AN (%)',
        withSortIcon: true,
        sortMethod: true,
        accessor: 'media_fea',
        minWidth: 100,
        defaultValue: '0,00%',
        footer: {
          mediaNacional: {
            accessor: 'media_fea',
            default: '-',
          },
        },
      },
      {
        header: 'Cópia (%)',
        withSortIcon: true,
        sortMethod: true,
        accessor: 'media_copia',
        minWidth: 100,
        defaultValue: '0,00%',
        footer: {
          mediaNacional: {
            accessor: 'media_copia',
            default: '-',
          },
        },
      },
      {
        header: 'FT (%)',
        withSortIcon: true,
        sortMethod: true,
        accessor: 'media_ft',
        defaultValue: '0,00%',
        minWidth: 100,
        footer: {
          mediaNacional: {
            accessor: 'media_ft',
            default: '-',
          },
        },
      },
      {
        header: 'NATT (%)',
        withSortIcon: true,
        sortMethod: true,
        accessor: 'media_natt',
        defaultValue: '0,00%',
        minWidth: 100,
        footer: {
          mediaNacional: {
            accessor: 'media_natt',
            default: '-',
          },
        },
      },
      {
        header: 'PD (%)',
        withSortIcon: true,
        sortMethod: true,
        accessor: 'media_pd',
        defaultValue: '0,00%',
        show: MODULE === 'enem',
        minWidth: 100,
        footer: {
          mediaNacional: {
            accessor: 'media_pd',
            default: '-',
          },
        },
      },
    ];
  }

  render() {
    const exportData = {
      url: `${API_URL}/v2/relatorios/distribuicao-notas-situacao/geral/excel`,
      filename: 'distribuicao_notas_por_situacao_geral.xlsx',
      hasPermission: this.hasPermission('exportar_relatorio'),
    };

    return (
      <Relatorio
        title="DISTRIBUIÇÃO DE SITUAÇÕES | Polos"
        dataUrl="v2/relatorios/distribuicao-notas-situacao/geral"
        mediaNacionalUrl="v2/relatorios/distribuicao-notas-situacao/geral/media"
        columns={this.columns}
        showAvaliadorInput={false}
        showTimeInput={false}
        codigo="DISTRIBUICAO_NOTAS_SITUACAO"
        exportData={exportData}
        codigoMensagem="DISTRIBUICAO_NOTAS_SITUACAO_POLOS"
      />
    );
  }
}

export default DistribuicaoNotasSituacaoGeral;
